export interface HfmqPair {
  priceUpTo: number;
  minPercentage: number;
}

export const HFMQ_PAIR_COUNT = 4;

export const defaultHfmqPairs = (): HfmqPair[] =>
  Array.from({ length: HFMQ_PAIR_COUNT }, () => ({ priceUpTo: 0, minPercentage: 0 }));

export const parseHfmqPairs = (value: string | undefined): HfmqPair[] => {
  if (!value) return defaultHfmqPairs();
  try {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- trusted API response
    const parsed = JSON.parse(value) as HfmqPair[];
    if (!Array.isArray(parsed) || parsed.length === 0) return defaultHfmqPairs();
    // Pad to HFMQ_PAIR_COUNT if fewer pairs are stored
    const result = [...parsed];
    while (result.length < HFMQ_PAIR_COUNT) {
      result.push({ priceUpTo: 0, minPercentage: 0 });
    }
    return result.slice(0, HFMQ_PAIR_COUNT);
  } catch {
    return defaultHfmqPairs();
  }
};
